// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Id from "@rescript/runtime/lib/es6/Belt_Id.js";
import * as Primitive_int from "@rescript/runtime/lib/es6/Primitive_int.js";

function toInt(button) {
  switch (button) {
    case "Main" :
      return 0;
    case "Auxiliary" :
      return 1;
    case "Secondary" :
      return 2;
    case "Fourth" :
      return 3;
    case "Fifth" :
      return 4;
  }
}

function fromInt(n) {
  switch (n) {
    case 0 :
      return "Main";
    case 1 :
      return "Auxiliary";
    case 2 :
      return "Secondary";
    case 3 :
      return "Fourth";
    case 4 :
      return "Fifth";
    default:
      return;
  }
}

function fromEvent(e) {
  return fromInt(e.button);
}

function fromPointerEvent(e) {
  return fromInt(e.button);
}

function cmp(x, y) {
  return Primitive_int.compare(toInt(x), toInt(y)) | 0;
}

let Cmp = Belt_Id.MakeComparable({
  cmp: cmp
});

export {
  toInt,
  fromInt,
  fromEvent,
  fromPointerEvent,
  Cmp,
}
/* Cmp Not a pure module */
